import dayjs from 'dayjs'

export const onlyDateFormatter = (value: string) => {
  return dayjs(value)?.format('DD-MM-YYYY') ?? ''
}
